import {DocumentGroupEnum} from '@dms/api/core';

import {Category} from '../types/Category';
import {TEMPLATE_CATEGORIES} from './TEMPLATE_CATEGORIES';

export const CATEGORY_BY_DOCUMENT_GROUP: Record<DocumentGroupEnum, Category> = {
  business_case: TEMPLATE_CATEGORIES.sales,
  vehicle: TEMPLATE_CATEGORIES.sales,
  vehicle_warehouse: TEMPLATE_CATEGORIES.sales,
  warehouse: TEMPLATE_CATEGORIES.afterSales,
  workshop: TEMPLATE_CATEGORIES.afterSales,
  pneu_hotel: TEMPLATE_CATEGORIES.afterSales,
  cash_register_document: TEMPLATE_CATEGORIES.accounting,
  accounting: TEMPLATE_CATEGORIES.accounting,
  car_audit: TEMPLATE_CATEGORIES.caraudit,
};
